import {isAfter} from '@/shared/dateTimeHelper';
import {createSharedComposable, useNow} from '@vueuse/core';
import {computed} from 'vue';

export const useBookingSunSetting = createSharedComposable(() => {
    const now = useNow({interval: 60 * 60 * 1000});
    const isOldBookingDeactivated = computed(() => isAfter(now.value, new Date('2026-02-18')));

    return {isOldBookingDeactivated};
});
